import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Workflow {
  id: string;
  name: string;
  status: string;
  created_at: string;
}

export default function Workflows() {
  const [workflows, setWorkflows] = useState<Workflow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '' });

  useEffect(() => {
    loadWorkflows();
  }, []);

  async function loadWorkflows() {
    try {
      setLoading(true);
      setError('');
      const res = await api.get('/api/workflows');
      setWorkflows(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api.post('/api/workflows', form);
      setForm({ name: '' });
      loadWorkflows();
    } catch (err: any) {
      setError(err.message);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Workflows</h1>
      {error && <div style={styles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          placeholder="Workflow name"
          value={form.name}
          onChange={(e) => setForm({ name: e.target.value })}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>
          Create
        </button>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Created</th>
            </tr>
          </thead>
          <tbody>
            {workflows.map((w) => (
              <tr key={w.id}>
                <td style={styles.td}>{w.name}</td>
                <td style={styles.td}>{w.status}</td>
                <td style={styles.td}>{new Date(w.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {workflows.length === 0 && (
              <tr>
                <td colSpan={3} style={{ ...styles.td, textAlign: 'center', color: '#9ca3af' }}>
                  No workflows yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  form: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: 14, border: '1px solid #e5e7eb', borderRadius: 6, minWidth: 200 },
  button: { padding: '8px 16px', fontSize: 14, background: '#111827', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#6b7280' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};
